import debounce from 'lodash/debounce';

class EqualHeights {
  /**
   * @param {Node} container The Container Node
   * @param {string} selector The CSS Selector for the items inside the container
   */
  constructor(container, selector) {
    if (container.length === 0 || container === null || container === undefined) {
      console.log('Equal Heights Expected a nodelist, found nothing');
      return;
    }

    const items = container.querySelectorAll(selector);
    if (items.length === 0 || items === null || items === undefined) {
      console.log('Equal Heights Found a container, but not items using the given selector');
      return;
    }

    this.items = items;
    this.equaliseHeights();

    window.addEventListener('resize', debounce(this.equaliseHeights, 100));
  }

  equaliseHeights = () => {
    let height = 0;

    // Get the Highest Element
    Array.forEach(this.items, (item) => {
      if (item.offsetHeight > height) {
        height = item.offsetHeight;
      }
    });

    // Now update them all to be it
    Array.forEach(this.items, (item) => {
      // eslint-disable-next-line no-param-reassign
      item.style.height = `${height}px`;
    });
  }
}

export default EqualHeights;
